module.exports = __webpack_public_path__ + "eg.e1ba2666.svg";